import { useEffect, useState } from "react";
import moment from "moment";
import { BloqueoMovimientosService } from "services/VacacionesService";

const FORMATO_API = "YYYY-MM-DD";

/**
 * Lee el bloqueo de movimientos vigente (fecha limite por empresa configurada desde
 * el administrador). Mientras este activo no se pueden solicitar ni aprobar
 * movimientos con fecha de inicio menor o igual a la fecha limite. El backend es
 * quien lo hace cumplir; esto solo mejora la experiencia (fechas deshabilitadas y avisos).
 *
 * @param {boolean} recargar vuelve a consultar cada vez que pasa a true (p. ej. al abrir un modal)
 */
const useBloqueoMovimientos = (recargar = true) => {
	const [fechaLimite, setFechaLimite] = useState(null);
	const [fechaMinimaSolicitud, setFechaMinimaSolicitud] = useState(null);

	useEffect(() => {
		if (!recargar) {
			return undefined;
		}
		let vigente = true;
		const cargar = async () => {
			try {
				const respuesta = await BloqueoMovimientosService.obtener();
				const fecha = respuesta?.estado === "EXITO" ? respuesta.data?.fechaLimiteVigente : null;
				const fechaMinima = respuesta?.estado === "EXITO" ? respuesta.data?.fechaMinimaSolicitud : null;
				if (vigente) {
					setFechaLimite(fecha ? moment(fecha, FORMATO_API) : null);
					setFechaMinimaSolicitud(fechaMinima ? moment(fechaMinima, FORMATO_API) : null);
				}
			} catch (error) {
				if (vigente) {
					setFechaLimite(null);
					setFechaMinimaSolicitud(null);
				}
			}
		};
		cargar();
		return () => {
			vigente = false;
		};
	}, [recargar]);

	const estaBloqueada = (fecha) => !!fechaLimite && !!fecha && moment(fecha).isSameOrBefore(fechaLimite, "day");

	const deshabilitarFechaBloqueada = (current) => !!current && estaBloqueada(current);

	// Ventana retroactiva (dias hacia atras desde hoy). Los tipos que permiten fechas anteriores no la aplican.
	const deshabilitarFueraDeVentana = (current, permiteFechasAnteriores) =>
		!permiteFechasAnteriores && !!fechaMinimaSolicitud && !!current && moment(current).isBefore(fechaMinimaSolicitud, "day");

	return { fechaLimite, fechaMinimaSolicitud, estaBloqueada, deshabilitarFechaBloqueada, deshabilitarFueraDeVentana };
};

export default useBloqueoMovimientos;
